/**
 * Système de z-index cohérent pour l'application
 * Utilisez ces constantes au lieu de valeurs hardcodées
 */
export const Z_INDEX = {
  // Base layers
  base: 0,
  content: 10,
  
  // Navigation & UI
  sticky: 40,          // NavBar sticky
  fab: 45,             // Floating action buttons
  bottomNav: 50,       // Bottom navigation mobile
  
  // Overlays
  dropdown: 60,        // Dropdowns, tooltips, popovers
  sidebar: 65,         // Sidebar/drawer
  modal: 70,           // Modals, dialogs
  toast: 80,           // Notifications, toasts
  critical: 90         // Cookie consent, critical alerts
} as const;

export type ZIndexKey = keyof typeof Z_INDEX;
